import React from 'react';
import { Route, Routes } from 'react-router-dom';
import QuizTopic from '../components/topics/quiz';
import Components from './components/components';
import Topics from '../components/topics/topics';

import './student.theme.less';

export interface IStartupProps {
  topicName: string;
  topicSettings: any[];
}

export function Student(props: IStartupProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={
          <Topics settings={props.topicSettings[0]} components={Components} />
        }
      />
      {props.topicSettings
        ?.filter((itm) => itm.id !== 'quiz')
        .map((topic: any) => (
          <Route
            key={topic.id}
            path={`/${topic.id}`}
            element={<Topics settings={topic} components={Components} />}
          />
        ))}
      <Route
        path="/quiz"
        element={
          <QuizTopic
            settings={props.topicSettings.find((itm) => itm.id === 'quiz')}
          />
        }
      />
    </Routes>
  );
}
